import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useCurrentApplication } from "../../../Context/CurrentApplicationContext/CurrentApplicationContext";
import CalendarSlot from "../../../Components/Calender/CalenderSlot";
import ScheduleDetails from "./ScheduleDetails";

const Interview = () => {
  const navigate = useNavigate();

  const { jobPost, jobApplication, refetch } = useCurrentApplication();

  const handleBack = () => {
    navigate("/", { replace: true });
  };

  const fetchAppliedJob = async () => {
    await refetch();
  };

  if (!jobApplication || !jobPost) {
    return null;
  }

  if (!jobPost.onlineInterview) {
    return null;
  }

  return (
    <div className="job-posts-details__card">
      <div className="job-posts-details__card-header">
        <div className="job-posts-details__job-title-header">
          <Button
            type="text"
            onClick={handleBack}
            icon={<ArrowLeftOutlined />}
          />
          <Typography.Title level={4} style={{ margin: 0 }}>
            Online Interview
          </Typography.Title>
        </div>
      </div>

      <div className="job-posts-details__sections">
        {!jobApplication.interviewSchedule && (
          <section className="job-posts-details__section">
            <CalendarSlot
              onSlotBooked={fetchAppliedJob}
              appliedJob={jobApplication}
              jobPostId={jobPost._id}
            />
          </section>
        )}

        {jobApplication.interviewSchedule && (
          <section className="job-posts-details__section">
            <ScheduleDetails />
          </section>
        )}
      </div>
    </div>
  );
};

export default Interview;
